module.exports = __webpack_public_path__ + "img/story004.37936bb5.webp";